import React from "react";
import "./Credit.css";

export default function Credit() {
  return (
    <div className="Credit">
      <a href="https://github.com/kriseliassen/weather-react">
        Open source code{" "}
      </a>
      by{" "}
      <a href="https://www.linkedin.com/in/kristineliassen/">
        Kristin Eliassen
      </a>
    </div>
  );
}
